if (typeof ProductPage !== "function") {
  class ProductPage extends HTMLElement {
    constructor() {
      super();

      if (!this.hasAttribute("data-empty-product")) {
        this.productGallery = this.querySelector(".product-gallery");
        this.productSlider = this.querySelector("css-slider");

        // Gallery thumbnails

        if (this.querySelector(".product-gallery__thumbnails .thumbnail")) {
          this.querySelectorAll(
            ".product-gallery__thumbnails .thumbnail",
          ).forEach((elm, i) => {
            if (i == 0) elm.classList.add("active");
            elm.addEventListener("click", (e) => {
              if (this.productSlider.sliderEnabled) {
                this.productSlider.changeSlide(e.currentTarget.dataset.index);
              } else {
                window.scrollTo({
                  top:
                    this.productGallery.querySelector(
                      `.product-gallery-item[data-faux-index="${e.currentTarget.hasAttribute("data-faux-index") ? e.currentTarget.dataset.fauxIndex : e.currentTarget.dataset.index}"]`,
                    ).offsetTop + this.offsetTop,
                  behavior: "smooth",
                });
                this.thumbnailNavigationHelper(
                  e.currentTarget.dataset.fauxIndex,
                );
              }
              this._pauseAllMedia();
              //playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
            });
          });

          if (this.productSlider) {
            this.productSlider.addEventListener("change", (e) => {
              this.thumbnailNavigationHelper(e.target.index);
            });
          }
        }

        if (this.productSlider) {
          this.productSlider.addEventListener("change", (e) => {
            if (
              this.productGallery.querySelector(
                `.product-gallery-item[data-index="${e.target.index}"]`,
              ).dataset.productMediaType == "model" &&
              this.xrButton
            ) {
              this.xrButton.setAttribute(
                "data-shopify-model3d-id",
                this.productGallery.querySelector(
                  `.product-gallery-item[data-index="${e.target.index}"]`,
                ).dataset.mediaId,
              );
            }
            this._pauseAllMedia();
            this.thumbnailNavigationHelper(e.target.index);
            //this.onVariantChangeHandler({ target: this.productVariants }, true);
          });
        }

        // Product variant event listener for theme specific logic

        this.productVariants = this.querySelector("product-variants");

        if (this.productVariants) {
          this.productVariants.addEventListener(
            "VARIANT_CHANGE",
            this.onVariantChangeHandler.bind(this),
          );

          this.onVariantChangeHandler({ target: this.productVariants });
        }

        // show cart drawer when element is added to cart

        if (
          !document.body.classList.contains("template-cart") &&
          KROWN.settings.cart_action == "overlay"
        ) {
          let addToCartEnter = false;
          if (this.querySelector(".product--add-to-cart-button")) {
            this.querySelector(".product--add-to-cart-button").addEventListener(
              "keyup",
              (e) => {
                if (e.keyCode == window.KEYCODES.RETURN) {
                  addToCartEnter = true;
                }
              },
            );
          }

          if (this.querySelector(".product--add-to-cart-form")) {
            // console.log(this.querySelector(".product--add-to-cart-form"));
            this.querySelector(".product--add-to-cart-form").addEventListener(
              "add-to-cart",
              () => {
                document.getElementById("site-cart").show();
                if (document.getElementById("cart-recommendations")) {
                  document
                    .getElementById("cart-recommendations")
                    .generateRecommendations();
                }
                if (addToCartEnter) {
                  setTimeout(() => {
                    document
                      .querySelector("#site-cart .site-close-handle")
                      .focus();
                  }, 200);
                }
              },
            );
          }
        }

        // Scroll navigation helper

        if (this.productGallery.dataset.style == "scroll") {
          this.productGalleryNavigation = this.querySelector(
            ".product-gallery__thumbnails",
          );
          this.productGalleryNavigationItem = this.querySelectorAll(
            ".product-gallery__thumbnails .thumbnail",
          );

          const productGallerySlides = this.productGallery.querySelectorAll(
            ".product-gallery-item",
          );
          const reversedGallerySlides = [...productGallerySlides].reverse();

          const checkIfProductIsFirst =
            this.parentNode ==
            document.querySelector("#main .mount-product-page:first-child")
              ? document.querySelector(
                  "#main .mount-product-page:first-child .product-gallery__thumbnails",
                )
              : false;

          this.GALLERY_NAVIGATION_SCROLL = () => {
            if (
              !this.productGallery.querySelector("css-slider").sliderEnabled &&
              window.innerWidth > 768
            ) {
              for (const slide of reversedGallerySlides) {
                const slideTop = slide.getBoundingClientRect().top;
                if (
                  slideTop < window.innerHeight / 2 &&
                  slideTop > -window.innerHeight / 2
                ) {
                  this.productGalleryNavigationItem.forEach((elm) =>
                    elm.classList.remove("active"),
                  );
                  this.productGalleryNavigationItem[
                    slide.dataset.fauxIndex
                  ].classList.add("active");
                  break;
                }
              }

              const productGalleryTop =
                this.productGallery.getBoundingClientRect().top;
              if (
                (productGalleryTop - window.innerHeight) * -1 >
                this.productGallery.offsetHeight
              ) {
                this.productGalleryNavigation.classList.add("scroll");
                this.productGalleryNavigation.classList.remove("scroll-up");
              } else if (productGalleryTop > 0) {
                this.productGalleryNavigation.classList.add("scroll-up");
                this.productGalleryNavigation.classList.add("scroll");
                if (checkIfProductIsFirst) {
                  checkIfProductIsFirst.style.height = `calc( var(--window-height) + ${window.scrollY}px )`;
                }
              } else if (
                (productGalleryTop - window.innerHeight) * -1 <
                this.productGallery.offsetHeight
              ) {
                this.productGalleryNavigation.classList.remove("scroll");
                this.productGalleryNavigation.classList.remove("scroll-up");
              }
            }
          };

          window.addEventListener("scroll", this.GALLERY_NAVIGATION_SCROLL, {
            passive: true,
          });
          this.GALLERY_NAVIGATION_SCROLL();
        }

        // Check for models

        const models = this.querySelectorAll("product-model");
        if (models.length > 0) {
          // window.ProductModel.loadShopifyXR();
          this.xrButton = this.querySelector(".product__view-in-space");
          const toggle3d = this.querySelector(".bubble--3d");
          toggle3d.addEventListener("click", (e) => {
            e.preventDefault();
            this.querySelector(".product-model__wrapper").classList.toggle(
              "active",
            );
          });
        }

        // Change sticky position for text content

        const productContentBox = this.querySelector(".box__product-content");
        const productGalleryBox = this.querySelector(".box__product-gallery");

        this.CONTENT_STICKY_RESIZE = () => {
          productContentBox.style.top = `calc(100vh - ${productContentBox.offsetHeight + 1}px)`;
          productGalleryBox.style.top = `calc(100vh - ${productGalleryBox.offsetHeight + 1}px)`;
        };
        window.addEventListener("resize", this.CONTENT_STICKY_RESIZE, {
          passive: true,
        });
        this.CONTENT_STICKY_RESIZE();

        const contentObserver = new MutationObserver((mutations) => {
          for (const mutation of mutations) {
            this.CONTENT_STICKY_RESIZE();
          }
        });
        contentObserver.observe(productContentBox, {
          attributes: true,
          childList: true,
          subtree: true,
        });

        // Assist for video popups

        if (this.productGallery.querySelector("video-popup")) {
          const productVideoObserver = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
              if (mutation.target.classList.contains("video-opened")) {
                this.productGallery.classList.add("remove-navigation");
              } else {
                this.productGallery.classList.remove("remove-navigation");
              }
            }
          });
          this.productGallery.querySelectorAll("video-popup").forEach((elm) => {
            productVideoObserver.observe(elm, {
              attributes: true,
              childList: false,
              subtree: false,
            });
          });
        }
      }

      // get the sticky element
      // var stickyElm = document.querySelector('.site-box.box__product-gallery')
      // console.log(stickyElm);
      // var observer = new IntersectionObserver(
      //   ([e]) => { console.log(e.boundingClientRect.top); e.target.classList.toggle('isSticky', e.boundingClientRect.top === 0)},
      //   { root: document.querySelector("body")},
      // );

      // observer.observe(stickyElm)

      // custom logic for handling swipes
      //this event listener is added twice which causes bugs
      // if (this.productSlider) {
      // this.productSlider.addEventListener("change", (e) => {
      //   this.onVariantChangeHandler({ target: this.productVariants }, true);
      // });
      // }
    }

    thumbnailNavigationHelper(index = 0) {
      /* Match the thumbnail to the slide by MEDIA ID, not position:
         reorderThumbnailNavigation() rewrites data-index on gear products, so
         thumbnail order and slide order diverge and the wrong thumb was marked
         active (VNM: variant media resolved to slide 3 while thumb 8 stayed lit).
         Falls back to positional matching when no media id is present, which is
         the case for the older product sections' thumbnails. */
      const currentSlide =
        this.productGallery &&
        this.productGallery.querySelector(
          `.product-gallery-item[data-index="${index}"]`,
        );
      const activeMediaId = currentSlide && currentSlide.dataset.mediaId;

      this.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach(
        (elm, i) => {
          const isActive =
            activeMediaId && elm.dataset.mediaId
              ? elm.dataset.mediaId === activeMediaId
              : i == index;
          if (!isActive) {
            elm.classList.remove("active");
            return;
          }
          elm.classList.add("active");
          /* The rail scrolls inside .thumbnails-holder (height 90%, overflow
             auto). Marking the thumb active without scrolling to it meant a
             variant change could highlight a thumbnail sitting below the fold —
             it looked like the rail simply didn't react. Rect maths rather than
             offsetTop so it doesn't depend on which ancestor is the offsetParent. */
          const holder = elm.closest(".thumbnails-holder");
          if (!holder || holder.scrollHeight <= holder.clientHeight) return;
          const offset =
            elm.getBoundingClientRect().top -
            holder.getBoundingClientRect().top +
            holder.scrollTop;
          holder.scrollTo({
            top: offset - (holder.clientHeight - elm.offsetHeight) / 2,
            behavior: "smooth",
          });
        },
      );
    }

    onVariantChangeHandler(e, swipe = false) {
      const variant = e.target.currentVariant;
      const fakeVariant = e.target.fakeVariant;

      if (variant && variant.featured_media != null) {
        const variantImg = this.productGallery.querySelector(
          `.product-gallery-item[data-media-id="${variant.featured_media.id}"]`,
        );

        if (variantImg) {
          this._updateSlider(variantImg, variant, swipe);
        }
      } else if (fakeVariant) {
        const variantImg = this.productGallery.querySelector(
          `.product-gallery-item[data-variant-option2="${fakeVariant}"]`,
        );

        if (variantImg) {
          this._updateSlider(variantImg, false, swipe);
        }
      } else {
        // console.log(e)
      }
    }

    _updateSlider(variantImage, variant, swipe) {
      if (!variantImage) return;

      const slider = this.productGallery.querySelector("css-slider");

      if (variant) {
        slider.cacheCurrentVariant(variant);
      }

      if (
        this.productGallery.dataset.style == "slider" ||
        (this.productGallery.dataset.style == "scroll" &&
          this.productGallery.querySelector("css-slider").sliderEnabled)
      ) {
        // this fixes swipes not being reflected in variants
        const nextIndex = swipe
          ? this.productGallery.querySelector("css-slider").index
          : variantImage.dataset.index;

        if (
          parseInt(this.productGallery.querySelector("css-slider").index) !==
          parseInt(variantImage.dataset.index)
        ) {
          const needsUpdate = swipe ? true : !variant.available;

          slider.changeSlide(nextIndex, "smooth", swipe, needsUpdate);
        }
        /* changeSlide() runs only when the slide has to move, and it is the only
           thing that fires the slider `change` which syncs the thumbnails. So a
           variant whose media was already on screen never told the rail, leaving
           it lit on the previous colour (measured on VNM: slider index correct,
           thumbnailNavigationHelper never called). Sync directly instead. */
        this.thumbnailNavigationHelper(parseInt(nextIndex));
      } else {
        const originalOrder = [
          ...this.productGallery.querySelectorAll(".product-gallery-item"),
        ].sort((a, b) => {
          return a.dataset.index - b.dataset.index;
        });

        if (
          Math.abs(this.productGallery.getBoundingClientRect().y) >
          window.innerHeight / 2
        ) {
          window.scrollTo({
            top: this.productGallery.offsetTop,
            behavior: "smooth",
          });
        }
        originalOrder.forEach((elm) => {
          this.productGallery.querySelector("css-slider").append(elm);
        });
        this.productGallery.querySelector("css-slider").prepend(variantImage);
        this.reorderThumbnailNavigation();
      }
    }

    reorderThumbnailNavigation(index) {
      const reversedGallerySlidesForThumbnails = [
        ...this.productGallery.querySelectorAll(".product-gallery-item"),
      ].reverse();
      const galleryThumbnailsHolder = this.querySelector(
        ".product-gallery__thumbnails .thumbnails-holder .thumbnails",
      );
      reversedGallerySlidesForThumbnails.forEach((slide) => {
        galleryThumbnailsHolder.prepend(
          this.querySelector(
            `.product-gallery__thumbnails .thumbnail[data-faux-index="${slide.dataset.index}"]`,
          ),
        );
      });
      this.querySelectorAll(
        ".product-gallery__thumbnails .thumbnails-holder .thumbnail",
      ).forEach((elm, i) => {
        elm.setAttribute("data-index", i);
      });
      this.thumbnailNavigationHelper(0);
      setTimeout(() => {
        this.thumbnailNavigationHelper(0);
      }, 10);
    }

    _pauseAllMedia() {
      document.querySelectorAll(".product .js-youtube").forEach((video) => {
        video.contentWindow.postMessage(
          '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
          "*",
        );
      });
      document.querySelectorAll(".product .js-vimeo").forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', "*");
      });
      document
        .querySelectorAll(".product video")
        .forEach((video) => video.pause());
      document.querySelectorAll(".product product-model").forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }

    _playMedia(media) {
      switch (media.dataset.productMediaType) {
        case "video":
          media.querySelector("video").play();
          break;
        case "external_video-youtube":
          media
            .querySelector(".js-youtube")
            .contentWindow.postMessage(
              '{"event":"command","func":"' + "playVideo" + '","args":""}',
              "*",
            );
          break;
        case "external_video-vimeo":
          media
            .querySelector(".js-vimeo")
            .contentWindow.postMessage('{"method":"play"}', "*");
          break;
      }
    }
  }

  if (typeof customElements.get("product-page") == "undefined") {
    customElements.define("product-page", ProductPage);
  }

  // addStickyCartButton();
}

function addStickyCartButton() {
  const button = document.querySelector(
    ".product__add-to-cart.product--add-to-cart-button.button.button--solid",
  );
  if (!button) {
    return;
  }

  let isSticky = false;
  document.addEventListener("scroll", () => {
    const rect = button.getBoundingClientRect();
    const isOnTopOfViewport = rect.y + rect.height < 0;
    if (isOnTopOfViewport && !isSticky) {
      isSticky = true;
      const newButton = button.cloneNode(true);
      newButton.id = "sticky-buy-button";
      newButton.classList.add("button-sticky");
      document.body.appendChild(newButton);
      return;
    }

    if (!isOnTopOfViewport) {
      isSticky = false;
      const stickyButton = document.querySelector(
        "#sticky-buy-button.button-sticky.product__add-to-cart.product--add-to-cart-button.button.button--solid",
      );
      if (stickyButton) {
        stickyButton.remove();
      }
      return;
    }
  });
}
